import { useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const QUESTIONS = [
    {   
        title:'週末理想生活',
        q: '在一個悠閒的週末，你最想如何度過？',
        qImg: './images/mpti/q1gold.png',
        qBg: './images/mpti/q1bg.jpg',
        a:[
            {
                text:'參加高級社交活動，結識志同道合的精英人士',
                aImg:'./images/mpti/btn/q1_a.png',
                ansKey:'e',
            },
            {
                text:'在家中享受寧靜時光，品味精緻咖啡或閱讀',
                aImg:'./images/mpti/btn/q1_b.png',
                ansKey:'i',
            },
            {
                text:'探索城市新開的米芝蓮餐廳或藝術展覽',
                aImg:'./images/mpti/btn/q1_c.png',
                ansKey:'i',
            },
            {
                text:'策劃一次精心安排的戶外活動或小型聚會',
                aImg:'./images/mpti/btn/q1_d.png',
                ansKey:'e',
            },
        ]
    },
    {
        title:'居住環境選擇',
        q: '選擇理想住所時，你最看重什麼？',
        qImg: './images/mpti/q2gold.png',
        qBg: './images/mpti/q2bg.jpg',
        a:[
            {
                text:'位處市中心地標建築，彰顯身份地位',
                aImg:'./images/mpti/btn/q2_a.png',
                ansKey:'s',
            },
            {
                text:'私密性高、環境優雅的獨立空間',
                aImg:'./images/mpti/btn/q2_b.png',
                ansKey:'n',
            },
            {
                text:'充滿設計感與藝術氛圍的創意空間',
                aImg:'./images/mpti/btn/q2_c.png',
                ansKey:'n',
            },
            {
                text:'社區配套完善、實用性強的優質住宅',
                aImg:'./images/mpti/btn/q2_d.png',
                ansKey:'s',
            },
        ]
    },
    {
        title:'消費決策方式',
        q: '面對高端消費選擇時，你會如何決定？',
        qImg: './images/mpti/q3gold.png',
        qBg: './images/mpti/q3bg.jpg',
        a:[
            {
                text:'選擇最具知名度和影響力的品牌',
                aImg:'./images/mpti/btn/q3_a.png',
                ansKey:'t',
            },
            {
                text:'深入研究產品細節，追求完美品質',
                aImg:'./images/mpti/btn/q3_b.png',
                ansKey:'t',
            },
            {
                text:'被獨特創新的設計或概念吸引',
                aImg:'./images/mpti/btn/q3_c.png',
                ansKey:'f',
            },
            {
                text:'考慮性價比和長期實用價值',
                aImg:'./images/mpti/btn/q3_d.png',
                ansKey:'f',
            },
        ]
    },
    {
        title:'社交互動偏好',
        q: '在高級社交場合中，你通常扮演什麼角色？',
        qImg: './images/mpti/q4gold.png',
        qBg: './images/mpti/q4bg.jpg',
        a:[
            {
                text:'主動社交，擴展人脈圈並分享見解',
                aImg:'./images/mpti/btn/q4_a.png',
                ansKey:'e',
            },
            {
                text:'選擇性互動，與少數深度交流的朋友相處',
                aImg:'./images/mpti/btn/q4_b.png',
                ansKey:'i',
            },
            {
                text:'觀察並欣賞環境氛圍，適時參與有趣對話',
                aImg:'./images/mpti/btn/q4_c.png',
                ansKey:'i',
            },
            {
                text:'協助組織活動，確保每個人都感到舒適',
                aImg:'./images/mpti/btn/q4_d.png',
                ansKey:'e',
            },
        ]
    },
    {
        title:'生活規劃態度',
        q: '對於未來的尊貴生活，你如何規劃？',
        qImg: './images/mpti/q5gold.png',
        qBg: './images/mpti/q5bg.jpg',
        a:[
            {
                text:'設定清晰的事業與社會地位目標',
                aImg:'./images/mpti/btn/q5_a.png',
                ansKey:'s+j',
            },
            {
                text:'專注於個人成長與內在修養提升',
                aImg:'./images/mpti/btn/q5_b.png',
                ansKey:'n+p',
            },
            {
                text:'保持開放彈性，追求多元體驗與可能性',
                aImg:'./images/mpti/btn/q5_c.png',
                ansKey:'n+p',
            },
            {
                text:'制定實際可行的階段性計劃',
                aImg:'./images/mpti/btn/q5_d.png',
                ansKey:'s+j',
            },
        ]
    },
    {
        title:'壓力應對方式',
        q: '面對工作或生活壓力時，你傾向如何放鬆？',
        qImg: './images/mpti/q6gold.png',
        qBg: './images/mpti/q6bg.jpg',
        a:[
            {
                text:'參與高端運動俱樂部或社交活動轉換心情',
                aImg:'./images/mpti/btn/q6_a.png',
                ansKey:'t',
            },
            {
                text:'獨自享受SPA、冥想或私人空間的寧靜',
                aImg:'./images/mpti/btn/q6_b.png',
                ansKey:'t',
            },
            {
                text:'嘗試新的興趣愛好或創意活動',
                aImg:'./images/mpti/btn/q6_c.png',
                ansKey:'f',
            },
            {
                text:'與親密朋友聚會或進行實際有益的活動',
                aImg:'./images/mpti/btn/q6_d.png',
                ansKey:'f',
            },
        ]
    },
]

const EXTRA_QUESTION = {
    'e+i':{   
        title:'能量來源',
        q: '在忙碌一週後,什麼能真正為你充電?',
        qImg: './images/mpti/q7gold.png',
        qBg: './images/mpti/q7bg.jpg',
        isExtraPb:'pb-[12%]',
        a:[
            {
                text:'參加專屬的人脈社交活動或多人晚宴',
                aImg:'./images/mpti/btn/q7_a.png',
                ansKey:'e',
            },
            {
                text:'在家中享受寧靜的夜晚,閱讀好書或從事個人愛好',
                aImg:'./images/mpti/btn/q7_b.png',
                ansKey:'i',
            },
        ]
    },
    's+n':{   
        title:'資訊處理',
        q: '在考慮奢侈品購買時,什麼首先吸引你的注意?',
        qImg: './images/mpti/q8gold.png',
        qBg: './images/mpti/q8bg.jpg',
        isExtraPb:'pb-[12%]',
        a:[
            {
                text:'具體規格、使用材料、實用功能和經過驗證的往績',
                aImg:'./images/mpti/btn/q8_a.png',
                ansKey:'s',
            },
            {
                text:'品牌背後的故事、創新概念以及它所代表的未來可能性',
                aImg:'./images/mpti/btn/q8_b.png',
                ansKey:'n',
            },
        ]
    },
    't+f':{   
        title:'決策方式',
        q: '在考慮奢侈品購買時,什麼首先吸引你的注意?',
        qImg: './images/mpti/q9gold.png',
        qBg: './images/mpti/q9bg.jpg',
        isExtraPb:'pb-[12%]',
        a:[
            {
                text:'客觀分析利弊,專注於邏輯結果和效率',
                aImg:'./images/mpti/btn/q9_a.png',
                ansKey:'t',
            },
            {
                text:'考慮決策如何影響相關人士,並符合個人價值觀',
                aImg:'./images/mpti/btn/q9_b.png',
                ansKey:'f',
            },
        ]
    },
}

const typeToImg = {
    enfj: 1,
    enfp:2,
    entj:3,
    entp:4,
    esfj:5,
    esfp:6,
    estj:7,
    estp:8,
    infj:9,
    infp:10,
    intj:11,
    intp:12,
    isfj:13,
    isfp:14,
    istj:15,
    istp:16,
}

function Screen(props) {
    const [screen, setScreen] = useState(0)
    const [score, setScore] = useState({})
    const [questions, setQuestions] = useState([...QUESTIONS])
    const [qResult, setQResult] = useState(null)
    const [questionReady, setQuestionReady] = useState(false)
    const [resultLoaded, setResultLoaded] = useState(false)

    useEffect(() => {
        if(questions.length <= 0) checkResult()
    },[questions])

    const checkResult = async () => {
        const types = [['e', 'i'],['s', 'n'],['t', 'f'],['j', 'p']]
        const extraQ = []
        let ans = ''
        for(const [type1, type2] of types){
            if(score?.[type1] === score?.[type2]){
                const newQ = EXTRA_QUESTION[`${type1}+${type2}`]
                extraQ.push(newQ)
            }else{
                (score?.[type1] || 0) > (score?.[type2] || 0) ? ans += type1 : ans += type2
            }
        }
        if(extraQ.length > 0) return setQuestions([...extraQ])
        setQResult(ans)
        setScreen(prev => prev + 1)
    }
    const anwserQ = (ansKey) => {
        if(!questionReady) return;
        setQuestionReady(false)
        const q = questions[0]
        const e1 = document.getElementById(q.title+'3')
        const e2 = document.getElementById(q.title+'2')
        const e3 = document.getElementById(q.title+'1')
        e1.classList.add('fadeout')
        e2.classList.add('fadeout')
        e3.classList.add('fadeout')
        setTimeout(() => {
            e1.classList.remove('fadeout')
            e2.classList.remove('fadeout')
            e3.classList.remove('fadeout')
            setTimeout(() => {
                setQuestionReady(true)
            },5000)
            setQuestions(prev => {
                prev.shift()
                return [...prev]
            })
        },500)
        setScore(prev => {
            if(ansKey.includes('+')){
                const [key1, key2] = ansKey.split('+')
                return {
                    ...prev,
                    [key1]: (prev?.[key1]+1 || 1),
                    [key2]: (prev?.[key2]+1 || 1)
                }
            }else{
                return {
                    ...prev,
                    [ansKey]: (prev?.[ansKey]+1 || 1)
                }
            }
        })
    }
    const share = async () => {
        try {
            const res = await fetch(`/images/mpti/result/${typeToImg[qResult]}.jpg`);
            const blob = await res.blob();
            const files = [new File([blob], `mpti_${typeToImg[qResult]}.jpg`, { type: blob.type })];
            if (navigator.canShare && navigator.canShare({ files })) {
                await navigator.share({
                    files: files,
                    title: 'T-Gather mbti result',
                    url: window.location.origin +`/images/mpti/result/${typeToImg[qResult]}.jpg`
                });
            } else if (navigator.share) {
                await navigator.share({
                    title: 'T-Gather mbti result',
                    url: window.location.origin +`/images/mpti/result/${typeToImg[qResult]}.jpg`
                });
            } else {
                alert('分享功能在您的裝置上不支援，請手動截圖或複製連結。');
            }
        } catch (err) {
            alert('分享失敗，請手動截圖或複製連結。');
        }
    }
    useEffect(() => {
        setTimeout(() => {
            setImgIdx(0)
        },1800)
    },[])
    const [imgIdx, setImgIdx] = useState(null)

    const startLoop = () => {
        setTimeout(() => {
            console.log('change')
            setImgIdx(prev => (prev + 1) % 4)
        },10000)
    }
    const resetGame = () => {
        setScore({})
        setScreen(0)
        setQResult(null)
        setQuestions([...QUESTIONS])
    }

    return(
        <div className="apti-app h-full flex items-center justify-center bg-black">
            {screen === 0 && <div className='mpti-vertical-view bg-black'>
                {/* preload img */}
                <>
                    <link rel="preload" href="./images/mpti/home/homebg.jpg" as="image" fetchpriority="high" />
                    <link rel="preload" href="./images/mpti/home/homegold.png" as="image" fetchpriority="high" />
                    <link rel="preload" href="./images/mpti/home/home_0.png" as="image" fetchpriority="high" />
                    <link rel="preload" href="./images/mpti/home/home_1.png" as="image" fetchpriority="high" />
                    <link rel="preload" href="./images/mpti/home/home_2.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/home/home_3.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q1bg.jpg" as="image" fetchpriority="high" />
                    <link rel="preload" href="./images/mpti/q2bg.jpg" as="image" fetchpriority="high" />
                    <link rel="preload" href="./images/mpti/q3bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q4bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q5bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q6bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q7bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q8bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q9bg.jpg" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q1gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q2gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q3gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q4gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q5gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q6gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q7gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q8gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/q9gold.png" as="image" fetchpriority="low" />
                    <link rel="preload" href="./images/mpti/end/end_bg.png" as="image" fetchpriority="low" />
                </>
                {/* ^preload img */}
                <div className='w-full h-full flex flex-col items-center relative'>
                    <img className='fadein w-full h-full absolute top-0 left-0' src={'./images/mpti/home/homebg.jpg'} style={{zIndex:1, animationDelay:'0s'}}></img>
                    <img className='fadein w-full h-full absolute top-0 left-0' src={'./images/mpti/home/homegold.png'} style={{zIndex:3, animationDelay:'1s'}}></img>
                    {imgIdx !== null && <img key={imgIdx} onLoad={startLoop} className='homechange w-[53%] absolute top-[47%] left-[23.5%]' src={`./images/mpti/home/home_${imgIdx}.png`} style={{zIndex:4}}></img>}
                    {imgIdx !== null && <div className='fadein absolute top-[10%] left-[83.5%]' style={{zIndex:4, animationDelay:'0s'}}>
                        <div className='homebgfloat' style={{zIndex:2, animationDelay:'0.8s', animationDuration:'5s'}}>
                            <img className='w-[63%]' src={`./images/mpti/home/ele_6.png`} style={{zIndex:2}}></img>
                        </div>
                    </div>}
                    {imgIdx !== null && <div className='fadein absolute top-[5%] left-[7%]' style={{zIndex:4, animationDelay:'0s'}}>
                        <div className='homebgfloat' style={{zIndex:2, animationDelay:'0.4s', animationDuration:'3s'}}>
                            <img className='w-[8%]' src={`./images/mpti/home/ele_6.png`} style={{zIndex:2}}></img>
                        </div>
                    </div>}
                    {imgIdx !== null && <div className='fadein absolute top-[82%] left-[17%]' style={{zIndex:3, animationDelay:'1.5s'}}>
                        <div className='homebgfloat' style={{zIndex:2, animationDelay:'1s', animationDuration:'5s'}}>
                            <img className='w-[18%]' src={`./images/mpti/home/ele_1.png`} style={{zIndex:3}}></img>
                        </div>
                    </div>}
                    {imgIdx !== null && <div className='fadein absolute top-[50%] left-[76.5%]' style={{zIndex:3, animationDelay:'0.6s'}}>
                        <div className='homebgfloat' style={{zIndex:2, animationDelay:'0.3s', animationDuration:'3s'}}>
                            <img className='w-[35%]' src={`./images/mpti/home/ele_3.png`} style={{zIndex:2, transform:'rotate(10deg)'}}></img>
                        </div>
                    </div>}
                    {imgIdx !== null && <div className='fadein absolute top-[58%] left-[9%]' style={{zIndex:4, animationDelay:'0.3s'}}>
                        <div className='homebgfloat' style={{animationDelay:'1s'}}>
                            <img className='w-[10%]' src={`./images/mpti/home/ele_4.png`} style={{transform:'rotate(-20deg)'}}></img>
                        </div>
                    </div>}
                    {imgIdx !== null && <div className='fadein absolute top-[70%] left-[80%]' style={{zIndex:3, animationDelay:'1s'}}>
                        <div className='homebgfloat' style={{zIndex:2, animationDelay:'0.8s', animationDuration:'4s'}}>
                            <img className='w-[49%]' src={`./images/mpti/home/ele_0.png`} style={{zIndex:2}}></img>
                        </div>
                    </div>}
                    <div className='fadein w-full flex flex-col items-center justify-end absolute top-[37%]' style={{zIndex:4, animationDelay:'1.2s'}}>
                        <img onClick={() => {
                            setScreen(prev => prev + 1);
                            setTimeout(() => {
                                setQuestionReady(true)
                            },5000)
                        }} className='w-[47%]' src={`./images/mpti/home/home_btn.png`}></img>
                    </div>
                </div>
            </div>}
            {screen === 1 && <div className='mpti-vertical-view bg-white'>
                {questions.length > 0 && <div className='w-full h-full flex flex-col items-center relative'>
                    <img id={questions[0].title + '1'} key={questions[0].title + '1'} className='fadein w-full h-full absolute top-0 left-0' src={questions[0].qBg} style={{zIndex:1}}></img>
                    <img id={questions[0].title + '2'} key={questions[0].title + '2'} className='fadein w-full h-full absolute top-0 left-0' src={questions[0].qImg} style={{zIndex:2, animationDelay:'1.5s'}}></img>
                    <div id={questions[0].title + '3'} key={questions[0].title + '3'} className={'w-full h-full text-black flex flex-col items-center justify-center ' + (questions[0]?.isExtraPb ? questions[0]?.isExtraPb : 'pb-[5%]')} style={{zIndex:3, animationDelay:'3s'}}>
                        {questions[0].a.map((obj, i) => <img key={'btn'+i} onClick={() => anwserQ(obj.ansKey)} src={obj.aImg} className='w-[70%] fadein' style={{animationDelay: `${(i * 0.2) + 3}s`}}>
                            
                        </img>)}
                    </div>
                </div>}
            </div>}
            {(screen === 2 && qResult) && <div className='mpti-vertical-view bg-white overflow-y-auto'>
                <link onLoad={() => setResultLoaded(true)} rel="preload" href={`./images/mpti/result/${typeToImg[qResult]}.jpg`} as="image" fetchpriority="high" />
                {resultLoaded && <>
                    <div className='w-full h-full flex flex-col items-center relative'>
                        <img className='fadein w-full h-full' src={'./images/mpti/end/end_bg.png'} style={{zIndex:1}}></img>
                        <img onClick={resetGame} className='absolute top-[3.5%] left-[7%] w-[15%]' src='./images/mpti/end/end_back.png' style={{zIndex:100}}></img>
                        <div className='absolute top-0 left-0 w-full flex flex-row justify-center pt-[9%]' style={{zIndex:99}}>
                            <img className='fadein w-[95%] rounded-xl dropshadow border border-white' src={`./images/mpti/result/${typeToImg[qResult]}.jpg`} style={{zIndex:1, animationDelay:'1s', aspectRatio:(1012/1579), height:undefined}}></img>
                        </div>
                        <div className='fadein w-full flex flex-col items-center justify-end absolute bottom-0' style={{zIndex:101, animationDelay:'1.5s'}}>
                            <img className='w-[40%] mb-[1%] select-none' src={`./images/mpti/end/end_copy.png`} ></img>
                            <img onClick={share} className='w-[45%] pb-[5%]' src={`./images/mpti/end/end_share.png`} ></img>
                        </div>
                    </div>
                    <div className=' w-full bg-black'>
                        <img className='w-full h-full' src={'./images/mpti/end/end_bg.png'} style={{zIndex:1}}></img>
                    </div>
                </>}
            </div>}
        </div>
    )
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Screen)